import React from 'react';
import moment from 'moment';

function DateFormat({children}) {
    return (
        <span>{new moment(children).format('YYYY/MM/DD')}</span>
    )
}

export default DateFormat;